'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: grid;
  max-width: 800px;
  margin: auto;
  gap: 0.75rem;
  grid-template-areas:
    'content'
    'video'
    'download';
  text-align: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    text-align: left;
    padding-left: 2.5rem;
    grid-template-columns: 1fr 0.8fr;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'content video'
      '.       video'
      'download video';
  }
`;

export const content = css`
  grid-area: content;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  @media screen and (width > ${theme.sizes.screens.md}) {
    padding-top: 1.5rem;
  }
`;

export const video = css`
  grid-area: video;
`;
export const download = css`
  grid-area: download;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding-bottom: 1.5rem;
  @media screen and (width > ${theme.sizes.screens.md}) {
    grid-template-columns: auto 1fr;
  }
`;

export const title = css`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.neutral[1]};
`;

export const seeMore = css`
  align-self: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    align-self: self-start;
  }
`;

export const qr = css`
  img {
    max-height: 90px;
  }
  display: none;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: initial;
  }
`;

export const downloadContent = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    align-items: flex-start;
  }
`;

export const downloadTitle = css`
  grid-area: title;
  font-weight: 600;
  color: ${theme.colors.primary[1]};
`;
export const downloadStore = css`
  grid-area: stores;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  img {
    max-width: 120px;
  }
`;
